import { newsList } from "../../data";
import ImageCarousel from "../../components/ImageCarousel";

const NewsList = () => {
  return (
    <div className="sidebar">
      <b style={{ fontSize: "28px", color: "brown" }}>News and Events</b>
      <div className="sidebar-item recent-posts"
         style={{
                     maxHeight: "500px",
                     overflowY: "auto",
                    paddingRight: "8px",
                   scrollbarWidth: "thin"
             }}
           >
        {newsList.map((news) => {
          const { id, image, title, link, date } = news;
          return (
            <div key={id} className="post-item clearfix" style={{ marginBottom: "10px" }}>
              <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <div style={{ flexShrink: 0, width: "200px", height: "100px" }}>
                  <ImageCarousel images={image} />
                </div>
                <div style={{ flex:1, minWidth: 0 }}>
                  <h5
                    style={{
                    
                      fontSize: "25px",
                      overflow: "hidden",
                      marginBottom: "8px" ,
                      display: "-webkit-box",
                        WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical", 
                    }}
                    title={title}
                  >
                    <a
                      href={link}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: "#0f5132", textDecoration: "none" }}
                    >
                    {title.substring(0, 50)}...
                    </a>
                  </h5>
                  <time style={{ fontSize: "16px", color: "#666", lineHeight: "1.5",marginTop: "4px" }}>{date}</time>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NewsList;
